
/* 非ascii字符检查 */
export function nonASCIIchar(str) {
  var chinese = /[\u4e00-\u9fa5]/
  var nonAsic = /[^\u0020-\u007e]/
  if (chinese.test(str)) return "Contains Chinese characters."
  else if (nonAsic.test(str)) return "Contains illegal characters."

  return null
}

